import { render, staticRenderFns } from "./Create-Project.vue?vue&type=template&id=3b0fb5bc&scoped=true"
import script from "./Create-Project.vue?vue&type=script&lang=js"
export * from "./Create-Project.vue?vue&type=script&lang=js"
import style0 from "./Create-Project.vue?vue&type=style&index=0&id=3b0fb5bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0fb5bc",
  null
  
)

export default component.exports